define(["data/config"], function(config) {
    var prefix = config.prefixes.component;
    var buttonClass = prefix + "uiButton";

    var apply = function($element, params) {
        var activeClass = buttonClass + "--" + params.activeClass;
        var inactiveClass = buttonClass + "--" + params.inactiveClass;

        var repaint = function($active) {
            $element
                .find("." + buttonClass)
                .removeClass()
                .addClass([buttonClass, inactiveClass].join(" "));
            $active
                .removeClass()
                .addClass([buttonClass, activeClass].join(" "));
            $element.trigger(config.events.buttonSwitchToggle, [
                $active,
                $active.attr("data-ui-button-switch-button-name")
            ]);
        };

        $element.on("click", "." + buttonClass, function(ev) {
            repaint($(this));
        });
        repaint($element.find("." + buttonClass).first());
    };

    return {
        apply: apply,
        defaultParameters: {
            activeClass: "main",
            inactiveClass: "hollow"
        },
        name: "uiButtonSwitch--tab"
    };
});
